module.exports = __webpack_public_path__ + "static/Mateusz-b2d9fa143cd9c55d6ad631e759934d03.mp4";